export default "__VITE_ASSET__D5it$s6t__"